import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SpinnerComponent } from './ui-elements/spinner/spinner.component';
import { DisplayErrorModalComponent } from './display-error/display-error-modal.component';
import { DisplayErrorService } from './display-error/display-error.service';
import { ConfirmActionComponent } from './confirm-action/confirm-action.component';
import { ConfirmActionModalComponent } from './confirm-action/confirm-action-modal.component';

@NgModule({ declarations: [
        SpinnerComponent,
        DisplayErrorModalComponent,
        ConfirmActionComponent,
        ConfirmActionModalComponent
    ],
    exports: [
        SpinnerComponent,
        ConfirmActionComponent,
        ConfirmActionModalComponent
    ], imports: [RouterModule,
        FormsModule,
        CommonModule], providers: [
        DisplayErrorService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SharedModule { }